module.exports = __webpack_public_path__ + "img/calendar.41e29c03.svg";